import{getDefaultExportFromCjs as e}from"./_commonjsHelpers.js";import{__require as t}from"../node_modules/.pnpm/react-text-mask@5.5.0_react@18.3.1/node_modules/react-text-mask/dist/reactTextMask.js";var r=e(t());export{r as default};
